const LYFT_RIDE_TOKEN_SECONDS = 50;
const LYFT_COUNTDOWN_TOKEN_TO_PROGRESS = 100/LYFT_RIDE_TOKEN_SECONDS;
const LYFT_RIDE_MODAL_STATUS_SECONDS_TO_CLOSE = 30;

const MESSAGE_TYPE = {
    callStoreMessage: 'callStoreMessage',
    promisedTimeMessage: 'promisedTimeMessage',
    promisedTimeMessageUpdate: 'promisedTimeMessageUpdate',
    vehicleReadyMessage: 'vehicleReadyMessage',
    beBackMessage: 'beBackMessage',
};

const PING_TYPE = {
    SmsSent: "SmsSent",
    VehicleReadySmsQueued: "VehicleReadySmsQueued",
    WorkOrderIngest: "WorkOrderIngest",
    NewNextAppt: "NewNextAppt",
    CourtesyRide: {
        NewRide: "NewRide",
        CancelRide: "CancelRide",
        UpdateRide: "UpdateRide"
    }
};

const WO_STATUS = {
    Waiting: "Waiting",
    Complete: "Complete",
    Tendered: "Tendered",
    Voided: "Voided"
};

const LYFT_RIDE_STATUSES = {
    scheduled: "scheduled",
    pending: "pending",
    accepted: "accepted",
    arrived: "arrived",
    pickedUp: "pickedUp",
    droppedOff: "droppedOff",
    canceled: "canceled",
    approaching: "approaching"
}

const LYFT_VALID_CANCEL_REASONS = [
    'driver', 
    'lyft',
    'passenger',
    'no_drivers_available',
    null
]

export { 
    LYFT_COUNTDOWN_TOKEN_TO_PROGRESS, 
    MESSAGE_TYPE, 
    PING_TYPE, 
    WO_STATUS, 
    LYFT_RIDE_STATUSES, 
    LYFT_RIDE_TOKEN_SECONDS,
    LYFT_RIDE_MODAL_STATUS_SECONDS_TO_CLOSE,
    LYFT_VALID_CANCEL_REASONS
}
